"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.METERS_PER_UNIT = void 0;
exports.fromCode = fromCode;

/**
 * @module ol/proj/Units
 */

/**
 * Projection units: `'degrees'`, `'ft'`, `'m'`, `'pixels'`, `'tile-pixels'` or
 * `'us-ft'`.
 * @enum {string}
 */
var Units = {
  /**
   * Radians
   * @api
   */
  RADIANS: 'radians',

  /**
   * Degrees
   * @api
   */
  DEGREES: 'degrees',

  /**
   * Feet
   * @api
   */
  FEET: 'ft',

  /**
   * Meters
   * @api
   */
  METERS: 'm',

  /**
   * Pixels
   * @api
   */
  PIXELS: 'pixels',

  /**
   * Tile Pixels
   * @api
   */
  TILE_PIXELS: 'tile-pixels',

  /**
   * US Feet
   * @api
   */
  USFEET: 'us-ft'
};
/**
 * See http://duff.ess.washington.edu/data/raster/drg/docs/geotiff.txt
 * @type {Object<number, Units>}
 */

var unitByCode = {
  '9001': Units.METERS,
  '9002': Units.FEET,
  '9003': Units.USFEET,
  '9101': Units.RADIANS,
  '9102': Units.DEGREES
};
/**
 * @param {number} code Unit code.
 * @return {Units} Units.
 */

function fromCode(code) {
  return unitByCode[code];
}
/**
 * Meters per unit lookup table.
 * @const
 * @type {Object<Units, number>}
 * @api
 */


var METERS_PER_UNIT = {}; // use the radius of the Normal sphere

exports.METERS_PER_UNIT = METERS_PER_UNIT;
METERS_PER_UNIT[Units.RADIANS] = 6370997 / (2 * Math.PI);
METERS_PER_UNIT[Units.DEGREES] = 2 * Math.PI * 6370997 / 360;
METERS_PER_UNIT[Units.FEET] = 0.3048;
METERS_PER_UNIT[Units.METERS] = 1;
METERS_PER_UNIT[Units.USFEET] = 1200 / 3937;
var _default = Units;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUlBOzs7OztBQUtBLElBQU1BLEtBQUssR0FBRztFQUNaOzs7O0VBSUFDLE9BQU8sRUFBRSxTQUxHOztFQU1aOzs7O0VBSUFDLE9BQU8sRUFBRSxTQVZHOztFQVdaOzs7O0VBSUFDLElBQUksRUFBRSxJQWZNOztFQWdCWjs7OztFQUlBQyxNQUFNLEVBQUUsR0FwQkk7O0VBcUJaOzs7O0VBSUFDLE1BQU0sRUFBRSxRQXpCSTs7RUEwQlo7Ozs7RUFJQUMsV0FBVyxFQUFFLGFBOUJEOztFQStCWjs7OztFQUlBQyxNQUFNLEVBQUU7QUFuQ0ksQ0FBZDtBQXNDQTs7Ozs7QUFJQSxJQUFNQyxVQUFVLEdBQUc7RUFDakIsUUFBUVIsS0FBSyxDQUFDSSxNQURHO0VBRWpCLFFBQVFKLEtBQUssQ0FBQ0csSUFGRztFQUdqQixRQUFRSCxLQUFLLENBQUNPLE1BSEc7RUFJakIsUUFBUVAsS0FBSyxDQUFDQyxPQUpHO0VBS2pCLFFBQVFELEtBQUssQ0FBQ0U7QUFMRyxDQUFuQjtBQVFBOzs7OztBQUlNLFNBQVVPLFFBQVYsQ0FBbUJDLElBQW5CLEVBQXVCO0VBQzNCLE9BQU9GLFVBQVUsQ0FBQ0UsSUFBRCxDQUFqQjtBQUNEO0FBRUQ7Ozs7Ozs7O0FBTU8sSUFBTUMsZUFBZSxHQUFHLEVBQXhCLEMsQ0FDUDs7O0FBQ0FBLGVBQWUsQ0FBQ1gsS0FBSyxDQUFDQyxPQUFQLENBQWYsR0FBaUMsV0FBVyxJQUFJVyxJQUFJLENBQUNDLEVBQXBCLENBQWpDO0FBQ0FGLGVBQWUsQ0FBQ1gsS0FBSyxDQUFDRSxPQUFQLENBQWYsR0FBa0MsSUFBSVUsSUFBSSxDQUFDQyxFQUFULEdBQWMsT0FBZixHQUEwQixHQUEzRDtBQUNBRixlQUFlLENBQUNYLEtBQUssQ0FBQ0csSUFBUCxDQUFmLEdBQThCLE1BQTlCO0FBQ0FRLGVBQWUsQ0FBQ1gsS0FBSyxDQUFDSSxNQUFQLENBQWYsR0FBZ0MsQ0FBaEM7QUFDQU8sZUFBZSxDQUFDWCxLQUFLLENBQUNPLE1BQVAsQ0FBZixHQUFnQyxPQUFPLElBQXZDO2VBRWVQLEsiLCJuYW1lcyI6WyJVbml0cyIsIlJBRElBTlMiLCJERUdSRUVTIiwiRkVFVCIsIk1FVEVSUyIsIlBJWEVMUyIsIlRJTEVfUElYRUxTIiwiVVNGRUVUIiwidW5pdEJ5Q29kZSIsImZyb21Db2RlIiwiY29kZSIsIk1FVEVSU19QRVJfVU5JVCIsIk1hdGgiLCJQSSJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvcHJvai9Vbml0cy5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==